import { render, staticRenderFns } from "./InteractionsPerPartnerChartInfoCard.vue?vue&type=template&id=14a57cb2"
import script from "./InteractionsPerPartnerChartInfoCard.vue?vue&type=script&lang=ts"
export * from "./InteractionsPerPartnerChartInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports